module.exports = __webpack_public_path__ + "img/usuario-compartido.654a1c70.png";